/**
 * Role-based landing path after login or when visiting "/".
 * Faculty land on the dashboard (diary remains reachable from nav).
 *
 * @param {string | undefined} role - user.role from auth
 * @param {{ role?: string, subtype?: string, facultyType?: string } | null | undefined} [_user]
 * @returns {string}
 */
export function getDefaultRoute(role, _user) {
  if (!role) return '/login';

  if (role === 'faculty' || role === 'cbcfaculty') {
    return '/faculty/dashboard';
  }

  switch (role) {
    case 'admin':
      return '/admin/overview';
    case 'student':
      return '/student/home';
    case 'hod':
      // HOD lands on the executive department dashboard.
      return '/hod/dashboard';
    default:
      return '/login';
  }
}
